import { Box, Select, Text } from "@chakra-ui/react";
import { createListCollection } from "@chakra-ui/react";

export function OnboardingSelect<T extends { label: string; value: string }>({
  label,
  collection,
  value,
  onValueChange,
  error,
}: {
  label?: string;
  collection: ReturnType<typeof createListCollection<T>>;
  value?: string;
  onValueChange: (details: { value: string[] }) => void;
  error?: string;
}) {
  return (
    <Box spaceY={1.5} data-onboarding-error={error ? "true" : undefined}>
      {label && (
        <Text fontSize="sm" fontWeight="medium" color="gray.700">
          {label}
        </Text>
      )}
      <Select.Root collection={collection} value={value ? [value] : []} onValueChange={onValueChange}>
        <Select.Control>
          <Select.Trigger
            ring={error ? "red.500" : "palomma.500"}
            borderColor={error ? "red.400" : undefined}
            focusRing="outside"
          >
            <Select.ValueText placeholder="Selecciona una opción..." />
          </Select.Trigger>
          <Select.IndicatorGroup>
            <Select.Indicator />
          </Select.IndicatorGroup>
        </Select.Control>
        <Select.Positioner>
          <Select.Content>
            {collection.items.map((item: { value: string; label: string }) => (
              <Select.Item key={item.value} item={item}>
                {item.label}
                <Select.ItemIndicator />
              </Select.Item>
            ))}
          </Select.Content>
        </Select.Positioner>
      </Select.Root>
      {error && <Text fontSize="xs" color="red.500">{error}</Text>}
    </Box>
  );
}
